// react core
import React, { useState, useEffect } from 'react';
import Select from 'react-select'
import { Link } from "react-router-dom";
import { NotificationManager } from 'react-notifications';

// components
import AjaxSpinner from 'components/commons/ajax_spinner';

// api
import { set_user_settings } from 'commons/api';
import usePageTitle from 'commons/page_title';

// confs
import conf from 'conf/ajax';

export default function NotificationPanel(props)
{
    usePageTitle('Notification Settings');
    const [tags_frequency, set_tags_frequency] = useState([]);
    const [question_frequency, set_question_frequency] = useState([]);
    const [user_prefs, set_user_prefs] = useState(null);
    const [is_loaded, set_is_loaded] = useState(false);
    const [send_data, set_send_data] = useState(
    {
        on_tags_frequency: null,
        on_questions_frequency: null
    });

    const get_full_tag_from_id = (id, mapper) =>
    {
        const tmp = mapper.filter(obj => obj.id === id);
        if (tmp.length > 0)
        {
            const obj = tmp[0];
            return {
                'id': obj.id,
                'label': obj.name || obj.label,
                'value': obj.id || obj.value
            }
        }
        return null;
    };

    const from_values_to_select_lsit = (arr) =>
    {
        return arr.map(id => ({ id: id, value: id, label: id }));
    };

    let load_schema = () =>
    {
        return new Promise((resolve, reject) =>
        {
            fetch(conf.endpoints.get_user_schema,
                conf.ajax_configuration_object)
                .then(res => res.json())
                .then(
                    (result) =>
                    {
                        if(result.status && result.status === 'ok')
                        {
                            resolve(result.data);
                        }
                        else
                        {
                            reject('error on getting schema, code');
                        }
                    },
                    (error) =>
                    {
                        reject(error);
                    }
                ).catch(err =>
                {
                    reject(err);
                });
        });
    };

    let load_datta = () =>
    {
        return new Promise((resolve, reject) =>
        {
            fetch(conf.endpoints.get_user_prefs,
                conf.ajax_configuration_object)
                .then(res => res.json())
                .then(
                    (result) =>
                    {
                        resolve(result);
                    },
                    (error) =>
                    {
                        reject(error);
                    }
                ).catch(err =>
                {
                    reject(err);
                });
        });
    }

    useEffect(() =>
    {
        let mounted = true;
        load_schema().then(schema =>
        {
            if (mounted)
            {
                set_tags_frequency(from_values_to_select_lsit(schema.frequency_on_followed_tags_values));
                set_question_frequency(from_values_to_select_lsit(schema.frequency_on_followed_questions_values));
            }
            load_datta().then(result =>
            {
                if (mounted)
                {
                    set_is_loaded(true);
                    set_user_prefs(result);
                    // setting base data
                    set_send_data(
                    {
                        on_questions_frequency: result.data.frequency_on_followed_questions || null,
                        on_tags_frequency: result.data.frequency_on_followed_tags || null
                    })
                }
            }).catch(err =>
            {
                console.log(err);
                set_is_loaded(true);
            })
        }).catch(err =>
        {
            console.log('error getting paghe schema');
            console.log(err);
            set_is_loaded(false);
        });
        return () => mounted = false; // cleanup function
    }, []);

    const handle_tags_change = (evt) =>
    {
        let updatedValue = {};
        updatedValue = {on_tags_frequency: evt.id};
        set_send_data(
            old_vals => ({
                ...old_vals,
                ...updatedValue
            })
        );
    };

    const handle_question_change = (evt) =>
    {
        let updatedValue = {};
        updatedValue = {on_questions_frequency: evt.id};
        set_send_data(
            old_vals => ({
                ...old_vals,
                ...updatedValue
            })
        );
    };

    const handle_save_prefs = async (evt) =>
    {
        const res = await set_user_settings(send_data)
        const data = await res.json();
        if(data.status === 'ok')
        {
            NotificationManager.success('the settings have been saved.');
        }
        else
        {
            NotificationManager.error('something went wrong, please try again later.', 'Ok!', 5000, () => {});
        }
    };

    if (!is_loaded || user_prefs === null)
    {
        return <AjaxSpinner tyoe="inline" />;
    }
    else
    {
        return (
            <>
                <div id="subheader">
                    <div id="subheader-header">
                        <h2>Notification settings</h2>
                    </div>
                    <div id="subheader-body">
                        <p>
                        Receive email updates on tags and questions you are interested in. You can adjust the
frequency of email updates at any moment. If do not wish to receive emails, select "never" on all items
below. Updates are only sent when there is any new activity on selected items.
                        </p>
                    </div>
                </div>

                <div id="notification-settings-form">
                    <div id="notification-settings-form-header">
                        <h3>Email frequency</h3>
                    </div>
                    <div id="notification-settings-form-body">

                        <div className="form-group">
                            <label>On followed tags</label>
                            <Select
                                options={tags_frequency}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="select frequency"
                                onChange={handle_tags_change}
                                defaultValue={get_full_tag_from_id(
                                    user_prefs?.data?.frequency_on_followed_tags,
                                    tags_frequency
                                )}
                            />
                            <span className="help-block">You can manage the list of followed tags from
                                the <Link to={conf.route.tags}>Browse by tag</Link> page
                            </span>
                        </div>
                        <div className="form-group">
                            <label>On followed Questions</label>
                            <Select
                                options={question_frequency}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="select frequency"
                                onChange={handle_question_change}
                                defaultValue={get_full_tag_from_id(
                                    user_prefs?.data?.frequency_on_followed_questions,
                                    question_frequency
                                )}
                            />
                            <span className="help-block">You can see the list of followed question from
                                the <Link to={conf.route.answers.replace(':id', '?order_by=FOLLOWED&sort_order=desc')}>Recently asked questions</Link> page
                            </span>
                        </div>
                    </div>
                    <div id="notification-settings-form-footer">
                        <button onClick={handle_save_prefs} className="button button-primary">Save</button>
                    </div>
                </div>
            </>
        );
    }
};
